var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHwExcessiveSpeedIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 13 13",
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    className: "hw_icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Excessive Speeding") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M3.86929 10.8616C4.46184 10.8616 4.9422 10.3813 4.9422 9.78873C4.9422 9.19618 4.46184 8.71582 3.86929 8.71582C3.27674 8.71582 2.79639 9.19618 2.79639 9.78873C2.79639 10.3813 3.27674 10.8616 3.86929 10.8616Z",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M3.86937 10.3027C4.1532 10.3027 4.38328 10.0726 4.38328 9.78881C4.38328 9.50499 4.1532 9.2749 3.86937 9.2749C3.58555 9.2749 3.35547 9.50499 3.35547 9.78881C3.35547 10.0726 3.58555 10.3027 3.86937 10.3027Z",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M10.0885 10.8616C10.6811 10.8616 11.1614 10.3813 11.1614 9.78873C11.1614 9.19618 10.6811 8.71582 10.0885 8.71582C9.49598 8.71582 9.01562 9.19618 9.01562 9.78873C9.01562 10.3813 9.49598 10.8616 10.0885 10.8616Z",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M10.0886 10.3027C10.3724 10.3027 10.6025 10.0726 10.6025 9.78881C10.6025 9.50499 10.3724 9.2749 10.0886 9.2749C9.80479 9.2749 9.57471 9.50499 9.57471 9.78881C9.57471 10.0726 9.80479 10.3027 10.0886 10.3027Z",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.74414 7.69824L3.31005 7.86887C3.91197 8.01589 4.53388 8.06351 5.15117 8.00984L9.27664 7.87659",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.01577 9.78809H4.94189",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M4.77002 6.58111C5.04668 6.55836 5.31968 6.54292 5.57399 6.54292C6.28289 6.54292 7.49677 6.43323 9.27899 7.87786C9.27899 7.87786 11.0462 7.62395 12.1609 8.5567C12.1609 8.5567 12.4453 9.78927 11.1599 9.78927",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M2.79777 9.79086H1.84593C1.80934 9.79116 1.77307 9.78404 1.7393 9.76994C1.70554 9.75584 1.67498 9.73505 1.64947 9.70881C1.62396 9.68258 1.60402 9.65145 1.59087 9.61731C1.57771 9.58316 1.57161 9.54671 1.57293 9.51014L1.58024 9.21439C1.58423 9.08587 1.63729 8.96375 1.72852 8.87314C1.81265 8.79048 1.86378 8.67999 1.87234 8.56236L1.93327 8.01595C2.04702 7.74295 2.74577 7.70152 2.74577 7.70152C2.90827 7.5772 3.04843 7.46264 3.17112 7.35742",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.57422 6.54199V7.99596",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.11123 4.93457H2.83154",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.94203 5.86523H0.8125",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.11137 6.79541H2.41162",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.07329 4.93457H1.69385",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.27344 6.79541H1.65287",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M9.94863 3.09583C9.97961 3.05101 10.0211 3.01444 10.0694 2.98927C10.1177 2.96411 10.1714 2.95113 10.2259 2.95144C10.2804 2.95176 10.334 2.96537 10.382 2.99109C10.43 3.01681 10.4711 3.05386 10.5015 3.09903L11.4633 4.47613L12.2941 5.6664C12.332 5.71985 12.3549 5.78253 12.3604 5.84786C12.3658 5.9132 12.3535 5.97879 12.3249 6.03777C12.2963 6.09674 12.2523 6.14694 12.1976 6.1831C12.143 6.21926 12.0796 6.24005 12.0141 6.24329L8.39973 6.22234C8.33433 6.21826 8.27122 6.19669 8.21701 6.15987C8.16281 6.12306 8.11949 6.07235 8.0916 6.01305C8.0637 5.95376 8.05226 5.88806 8.05846 5.82283C8.06466 5.75759 8.08827 5.69522 8.12684 5.64224L8.97098 4.46168L9.94863 3.09583Z",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4239 3.80832C10.4478 4.04014 10.4497 4.2737 10.4296 4.50589C10.4159 4.73955 10.3882 4.97218 10.3468 5.20255C10.3399 5.22868 10.3245 5.25178 10.303 5.26821C10.2816 5.28464 10.2553 5.29347 10.2282 5.29331C10.2012 5.29315 10.175 5.28402 10.1537 5.26734C10.1325 5.25066 10.1174 5.22739 10.1108 5.20118C10.0712 4.97042 10.0458 4.73746 10.0348 4.5036C10.0174 4.2712 10.022 4.03768 10.0486 3.80614C10.0545 3.76053 10.0768 3.71865 10.1115 3.68839C10.1461 3.65813 10.1906 3.64157 10.2366 3.64184C10.2826 3.6421 10.3269 3.65917 10.3612 3.68983C10.3955 3.7205 10.4173 3.76263 10.4227 3.80831L10.4239 3.80832Z",
    fill: "currentColor",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2274 5.39778C10.1833 5.39752 10.1401 5.41036 10.1033 5.43467C10.0664 5.45899 10.0376 5.49368 10.0205 5.53436C10.0034 5.57503 9.99878 5.61987 10.0072 5.6632C10.0156 5.70652 10.0366 5.74638 10.0677 5.77774C10.0987 5.8091 10.1384 5.83054 10.1816 5.83935C10.2248 5.84816 10.2697 5.84394 10.3106 5.82724C10.3514 5.81053 10.3864 5.78208 10.4111 5.74549C10.4357 5.70891 10.449 5.66582 10.4492 5.62169C10.4493 5.59242 10.4437 5.56341 10.4327 5.53631C10.4216 5.50921 10.4053 5.48455 10.3847 5.46375C10.3641 5.44295 10.3396 5.42642 10.3126 5.4151C10.2857 5.40378 10.2567 5.39789 10.2274 5.39778Z",
    fill: "currentColor",
    strokeWidth: 0.3
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHwExcessiveSpeedIcon);
export default __webpack_public_path__ + "static/media/hw_excessive_speed_icon.85b3479169d03f7bff28bdcf38c47d7e.svg";
export { ForwardRef as ReactComponent };